import styled from 'styled-components';
import { motion } from 'framer-motion';

export const AccordionContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 1rem;
  background: #fff;
  width: 100%;
`;

export const AccordionHeader = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: #f9f9f9;
  border-bottom: 1px solid #eee;

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const AccordionTitle = styled.h4`
  margin: 0;
  font-size: 1.1rem;
  color: #333;
`;

export const AccordionIcon = styled.span`
  font-size: 1.2rem;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

export const AccordionMotionContent = styled(motion.div)`
  overflow: hidden;
  width: 100%;
  padding: 0 1rem;
  border-top: 1px solid #eee;
`;